export enum EDirection {
  Ltr = "ltr",
  Rtl = "rtl",
}

export type TAutoDirection = EDirection | "auto";

export interface IDirectionProps {
  value: string;
  fallback: EDirection;
}

export interface IGetAutoDirectionProps {
  isDisabled?: boolean;
  content?: string;
}
